<div class="content">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <img src="../../../../assets/images/business_service_qrcode.jpg" alt="" />
  <div class="txt1">添加官方运营总监</div>
  <div class="txt2">获取博主专属高佣通道与推广扶持</div>
</div>
